// Load plugins
import cash from "cash-dom";
import Velocity from "velocity-animate";
import * as Popper from "@popperjs/core";

// Set plugins globally
window.$ = cash;
window.cash = cash;
window.Velocity = Velocity;
window.Popper = Popper;
